import article_img1 from './../../Assets/images/blog/main-blog1.png';
import article_img2 from './../../Assets/images/blog/main-blog2.png'
import article_img3 from './../../Assets/images/blog/blog-3.webp';

export const recentArticlesData = [
    {
        img: article_img1,
        title:"Best Quality Food in the Market",
        badge:"Vegetables"
    },
    {
        img: article_img2,
        title:"Best way to eat Dry Fruits and Nuts",
        badge:"Fruits"
    },
    {
        img: article_img3,
        title:"Fruits & Vegetable Nutrients And Health Benefits",
        badge:"Vegetables"
    },
]